import React from 'react';
import styled from 'styled-components';

import { formattedDateTime } from '../../../utils/dateUtils';
import { isDefined } from '../../../utils/variables';
import { Stack } from '../stack/stack';

type Props = {
  activationDate?: Date;
  children: React.ReactNode;
};

const IntegrationTitle = (props: Props) => {
  return (
    <Component direction="column" spacing={0.2}>
      <h1 className="notranslate">{props.children}</h1>

      {isDefined(props.activationDate) && (
        <time
          dateTime={props.activationDate.toISOString()}
          title={`Aktiverad ${formattedDateTime(props.activationDate)}`}
        >
          {formattedDateTime(props.activationDate)}
        </time>
      )}
    </Component>
  );
};

const Component = styled(Stack)`
  h1 {
    font-weight: 500;
    font-size: 1.2em;
    margin: 0;
  }

  time {
    font-size: 0.9em;
    font-style: italic;
  }
`;

export { IntegrationTitle };
